/*jshint esversion: 11 */

// Performance | Function for checking if an element exists before running code associated with it
function runIfElementExists(selector, callback) {
    document.addEventListener('DOMContentLoaded', function () {
        const el = document.querySelector(selector);
        if (!el) {
            console.warn(`Element '${selector}' not found. Skipping associated functions.`);
            return;
        }
        callback(el);
    });
}

/*
*
* Helper function to calculate the height of the header and footer and create a set of css custom
* properties for calc functions to use to offset the viewport height.
*
* */

function updateCalcHeight() {
    if (document.body.classList.contains('page-template-elementor_canvas')) return;

    const siteHeader = document.querySelector('.kcss_site-header--scroll-hide'); // <-- the fixed header element
    const headerWrapper = document.querySelector('.elementor-location-header'); // fallback only
    const footerElement = document.querySelector('.elementor-location-footer');

    // Measure header from the ACTUAL header element first
    let headerHeight =
        siteHeader?.getBoundingClientRect().height ||
        headerWrapper?.getBoundingClientRect().height ||
        0;

    const footerHeight = footerElement?.getBoundingClientRect().height || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // Guard: don’t stomp a previously valid value with 0 due to layout state changes
    const prev = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--kcss-header-height')
    );
    if ((!headerHeight || headerHeight < 1) && Number.isFinite(prev) && prev > 0) {
        headerHeight = prev;
    }

    document.documentElement.style.setProperty('--kcss-header-footer-height', (headerHeight + footerHeight) + 'px');
    document.documentElement.style.setProperty('--kcss-viewport-height', viewportHeight + 'px');
    document.documentElement.style.setProperty('--kcss-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--kcss-footer-height', footerHeight + 'px');
}

window.updateCalcHeight = updateCalcHeight;

document.addEventListener('DOMContentLoaded', updateCalcHeight);
window.addEventListener('load', updateCalcHeight);
window.addEventListener('resize', updateCalcHeight);

// ResizeObserver: observe the REAL header + footer (not the collapsing wrapper)
(() => {
    if (!('ResizeObserver' in window)) return;

    const ro = new ResizeObserver(() => updateCalcHeight());

    const siteHeader = document.querySelector('.js-scroll-header');
    const footer = document.querySelector('.elementor-location-footer');

    if (siteHeader) ro.observe(siteHeader);
    if (footer) ro.observe(footer);
})();

let windowResizeTimer;

window.addEventListener('resize', function() {
    // Clear the previous timeout (if any)
    clearTimeout(windowResizeTimer);

    // Set a new timeout to delay execution of the handler
    windowResizeTimer = setTimeout(function() {
        // Your code to handle the resize event goes here
        console.log('Resizing has stopped');
        updateCalcHeight();
    }, 500); // Adjust the delay (in milliseconds) as needed
});

// Accessibility
// Function for checking if we should avoid animating too many items
document.addEventListener('DOMContentLoaded', function() {

    // Check if the user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        console.log('Reduced motion enabled.');
        return;
    } else {
        document.body.setAttribute("data-animated", true);
    }

});

// Accessibility | SEO
// Function enabling clicking anywhere a card to open a link inside it
document.addEventListener('DOMContentLoaded', () => {

    // Prevent running inside Elementor editor
    if (document.body.classList.contains('elementor-editor-active')) return;

    document.body.addEventListener('click', function (event) {
        let card = event.target.closest('.kcss_card');

        // Ensure the click is within a valid card, and NOT on an interactive element inside it
        if (card && !event.target.closest('a, button, input, textarea, select, label')) {
            let link = card.querySelector('a');
            if (link) {
                link.click();
            }
        }
    });

});

function overflowScrollState() {
    const targetSelector = '.elementor-toc__body, .kcss_overflow-inner-shadow';

    function updateState(el) {
        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;

        const atTop = scrollTop <= 10;
        const atEnd = scrollTop + clientHeight >= scrollHeight - 10;

        el.classList.remove(
            'overflow-state-scroll-top',
            'overflow-state-scrolled',
            'overflow-state-scroll-end'
        );

        if (scrollHeight <= clientHeight) return;

        if (atTop) {
            el.classList.add('overflow-state-scroll-top');
        } else if (atEnd) {
            el.classList.add('overflow-state-scroll-end');
        } else {
            el.classList.add('overflow-state-scrolled');
        }
    }

    function throttle(fn, limit) {
        let inThrottle;
        return function (...args) {
            if (!inThrottle) {
                fn.apply(this, args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
            }
        };
    }

    function initScrollState(el) {
        if (!el || el.dataset.overflowStateInit === 'true') return;

        el.dataset.overflowStateInit = 'true';

        if (el.scrollHeight <= el.clientHeight) return;

        updateState(el);

        const throttledHandler = throttle(() => updateState(el), 100);
        el.addEventListener('scroll', throttledHandler, { passive: true });

        window.addEventListener('resize', () => updateState(el));
    }

    // Observe when TOC body is populated
    const observer = new MutationObserver((mutations, obs) => {
        const tocBodies = document.querySelectorAll(targetSelector);

        tocBodies.forEach((el) => {
            if (
                el.querySelector('li, .elementor-toc__list-item') &&
                !el.dataset.overflowStateInit
            ) {
                initScrollState(el);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Safety timeout fallback after 2 seconds
    setTimeout(() => {
        document.querySelectorAll(targetSelector).forEach(initScrollState);
    }, 2000);
}

document.addEventListener('DOMContentLoaded', () => {
    overflowScrollState();
});

// Accessibility
// Function to check colour contrast of text on backgrounds logged in console
// Source: https://www.w3.org/TR/WCAG21/#contrast-minimum
// Source: https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio
// Todo add functionality to adapt colours to WCAG 2.1 AA contrast ratio
document.addEventListener('DOMContentLoaded', function() {
    const wysiwygTxt = document.querySelectorAll('.elementor-widget-text-editor');

    if (wysiwygTxt.length > 0) {
        checkAncestorBgColor();
    } else {
        console.log('No elements found with the class .elementor-widget-text-editor');
    }

    function checkAncestorBgColor() {
        wysiwygTxt.forEach((item) => {
            let currentElement = item.closest('.e-con');
            let backgroundColor = null;

            while (currentElement) {
                const computedStyle = window.getComputedStyle(currentElement);
                backgroundColor = computedStyle.backgroundColor;

                if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
                    break;
                }

                if (currentElement.classList.contains('e-parent')) {
                    break;
                }

                currentElement = currentElement.parentElement;
            }

            if (backgroundColor) {
                const textColor = window.getComputedStyle(item).color;
                const contrastRatio = getContrastRatio(textColor, backgroundColor);

                if (contrastRatio < 4.5) { // WCAG 2.1 AA minimum for normal text
                    item.classList.add('low-contrast-warning');
                    console.warn(`Low contrast detected: ${contrastRatio.toFixed(2)} (Text: ${textColor} on Background: ${backgroundColor})`);
                }
            }
        });
    }

    function getContrastRatio(foreground, background) {
        const fgLuminance = getLuminance(foreground);
        const bgLuminance = getLuminance(background);
        return (Math.max(fgLuminance, bgLuminance) + 0.05) / (Math.min(fgLuminance, bgLuminance) + 0.05);
    }

    function getLuminance(color) {
        const rgb = color.match(/\d+/g).map(Number);
        const [r, g, b] = rgb.map(c => {
            c /= 255;
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }
});

// UX | Accessibility
// Function to add dismiss button functionality to WooCommerce notices
document.addEventListener('DOMContentLoaded', function() {

    const notices = document.querySelectorAll('.woocommerce-info, .woocommerce-message, .woocommerce-error');

    notices.forEach(notice => {
        // Only add button if it doesn't already exist
        if (!notice.querySelector('.notice-dismiss')) {
            // Wrap existing content in notice-text span
            const content = notice.innerHTML;
            notice.innerHTML = `<span class="notice-text">${content}</span>`;

            // Add dismiss button
            const dismissButton = document.createElement('button');
            dismissButton.type = 'button';
            dismissButton.className = 'notice-dismiss';
            dismissButton.setAttribute('aria-label', 'Dismiss notice');
            dismissButton.textContent = 'Dismiss';

            notice.appendChild(dismissButton);

            // Add click handler
            dismissButton.addEventListener('click', () => {
                notice.style.opacity = '0';
                setTimeout(() => {
                    notice.remove();
                }, 300);
            });
        }
    });

    // The existing Escape key handler remains the same
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const visibleNotices = document.querySelectorAll('.woocommerce-info, .woocommerce-message, .woocommerce-error');
            visibleNotices.forEach(notice => {
                notice.style.opacity = '0';
                setTimeout(() => {
                    notice.remove();
                }, 300);
            });
        }
    });
});

// UX | Accessibility
// Custom accordion requires a specific Kameleon Built Elementor Section Setup to work
// Comprehensive theming via custom properties from style.css and /css/kcss-utils.css
// Accessibility via keyboard navigation and focus management is included via this script
// along with appropriately applied "Aria-" attributes to support screen readers and
// assistive technology – classes and structure required for this to fundamentally work:
// Wrapper Container with class: .kcss_accordion-wrapper (script will not run without this)
// – Container with elementor heading widget with class: .kcss_toggle-all-accordion-panes
// – Container with class: .kcss_accordion-item
// –– Container with class: .kcss_accordion-item-heading containing an elementor heading widget
// –– Container with class: .kcss_accordion-item-content-wrapper
// ––– Container with class .kcss_accordion-item-content-inner containing any* widgets needed
// *not comprehensively tested – basic widgets working as expected (WYSIWYG, images, button, icon list)
// Supports nested sub-accordions that operate independently from their parent accordion – just
// add another accordion inside the content area of an accordion item. This is not recommended generally
// as it will be very nested.

runIfElementExists('.kcss_accordion-wrapper', function () {
    /**
     * KCSS Accordion Controller
     * ========================
     *
     * Goals
     * -----
     * 1) DRY: centralize repeated logic (selection, transitions, ARIA wiring).
     * 2) Predictable: one Escape handler + one ResizeObserver for all accordions.
     * 3) Nested-safe: only operate on the “current accordion level”.
     * 4) Accessible: ARIA roles/relationships and keyboard support.
     *
     * Dependencies / assumptions
     * --------------------------
     * Markup structure per item (top-level within a wrapper):
     *   .kcss_accordion-wrapper
     *     .kcss_accordion-item
     *       .kcss_accordion-item-heading
     *       .kcss_accordion-item-content-wrapper
     *         .kcss_accordion-item-content-inner
     *
     * What breaks if removed
     * ----------------------
     * - Remove initAllAccordions(): new wrappers won’t initialize.
     * - Remove the singleton Escape handler: ESC close becomes unreliable / duplicated per wrapper.
     * - Remove the singleton ResizeObserver: open panels may not resize correctly when content changes.
     * - Remove transition cancellation: rapid click / toggle-all can “stick” mid-animation.
     *
     * Debugging
     * ---------
     * Toggle debug logging:
     *   KCSS_Accordion.setDebug(true);
     * Force re-scan:
     *   KCSS_Accordion.rewire();
     */

        // ---------------------------------------------------------------------------
        // Configuration
        // ---------------------------------------------------------------------------
    const CONFIG = {
            debug: false,

            wrapperSelector: '.kcss_accordion-wrapper',
            itemSelector: '.kcss_accordion-item',
            headSelector: '.kcss_accordion-item-heading',
            contentWrapperSelector: '.kcss_accordion-item-content-wrapper',
            contentInnerSelector: '.kcss_accordion-item-content-inner',
            toggleAllSelector: '.kcss_toggle-all-accordion-panes',

            // Initial state attributes (closed by default)
            wrapperOpenAllAttr: 'data-kcss-accordion-open-all', // wrapper: open everything initially
            itemOpenAttr: 'data-kcss-accordion-open',           // item OR heading: open this item initially

            // Animation
            transitionMs: 300,
            transitionCss: 'height 300ms ease',

            // Internal attribute to prevent double-init
            readyAttr: 'data-kcss-accordion-ready'
        };

    // ---------------------------------------------------------------------------
    // Debug logger
    // ---------------------------------------------------------------------------
    function log() {
        if (!CONFIG.debug) return;
        console.log.apply(console, ['[KCSS Accordion]'].concat([].slice.call(arguments)));
    }
    function warn() {
        if (!CONFIG.debug) return;
        console.warn.apply(console, ['[KCSS Accordion]'].concat([].slice.call(arguments)));
    }

    // ---------------------------------------------------------------------------
    // Internal registries (singleton state)
    // ---------------------------------------------------------------------------

    // Unique wrapper IDs (stable even if DOM reorders)
    let wrapperUidCounter = 0;

    // Wrapper -> instance state
    const instances = new Map();

    // Track transition state and pending transitionend handlers per contentWrapper
    const isTransitioning = new WeakMap();      // contentWrapper -> boolean
    const pendingHandler = new WeakMap();       // contentWrapper -> function|null

    // Store original computed display for each contentWrapper so we can restore correctly
    const originalDisplay = new WeakMap();      // contentWrapper -> string

    // Map contentWrapper -> contentInner (avoid mutating DOM nodes with custom properties)
    const contentInnerByWrapper = new WeakMap(); // contentWrapper -> contentInner

    // For ResizeObserver: contentInner -> contentWrapper
    const wrapperByInner = new WeakMap();       // contentInner -> contentWrapper

    // Head -> instance (lets us open parent chains reliably)
    const headToInstance = new WeakMap();

    // Ensure we only apply initial-open logic once per instance (rewire-safe)
    const initialApplied = new WeakSet();

    // ---------------------------------------------------------------------------
    // Helpers: DOM scoping / nested-safe selection
    // ---------------------------------------------------------------------------
    function isContentWrapperEl(el) {
        return !!(el && el.matches && el.matches(CONFIG.contentWrapperSelector));
    }

    function isTopLevelInWrapper(el, wrapper) {
        // Ensures nested accordions are ignored by this wrapper’s logic.
        return el && el.closest(CONFIG.wrapperSelector) === wrapper;
    }

    function getTopLevelItems(wrapper) {
        const all = Array.from(wrapper.querySelectorAll(CONFIG.itemSelector));
        return all.filter(function (item) {
            return isTopLevelInWrapper(item, wrapper);
        });
    }

    function getHeadForItem(item) {
        return item.querySelector(':scope > ' + CONFIG.headSelector);
    }

    function getContentWrapperForItem(item) {
        return item.querySelector(':scope > ' + CONFIG.contentWrapperSelector);
    }

    function contentWrapperBelongsToInstance(instance, contentWrapper) {
        if (!instance || !contentWrapper) return false;
        for (let i = 0; i < instance.items.length; i += 1) {
            if (getContentWrapperForItem(instance.items[i]) === contentWrapper) return true;
        }
        return false;
    }

    function getContentInnerForWrapper(contentWrapper) {
        if (!contentWrapper) return null;
        // Prefer known mapping (set during init), fallback to query
        return contentInnerByWrapper.get(contentWrapper) || contentWrapper.querySelector(':scope > ' + CONFIG.contentInnerSelector);
    }

    function getToggleAllForWrapper(wrapper) {
        const candidates = Array.from(wrapper.querySelectorAll(CONFIG.toggleAllSelector));
        // Only allow toggle-all if it belongs to THIS wrapper level
        for (let i = 0; i < candidates.length; i += 1) {
            if (isTopLevelInWrapper(candidates[i], wrapper)) return candidates[i];
        }
        return null;
    }

    function isTruthyAttr(value) {
        const v = String(value || '').trim().toLowerCase();
        return v === 'true' || v === '1' || v === 'yes' || v === 'open';
    }

    function wrapperWantsOpenAll(wrapper) {
        if (!wrapper) return false;
        const attr = wrapper.getAttribute(CONFIG.wrapperOpenAllAttr);
        return isTruthyAttr(attr);
    }

    function itemWantsOpen(item, head) {
        // Allow either on the item or the head for flexibility
        const itemAttr = item ? item.getAttribute(CONFIG.itemOpenAttr) : '';
        const headAttr = head ? head.getAttribute(CONFIG.itemOpenAttr) : '';
        return isTruthyAttr(itemAttr) || isTruthyAttr(headAttr);
    }

    /**
     * Open/close immediately WITHOUT animation.
     * Why:
     * - Initial state should be stable (no “accordion animates on load”).
     * - Keeps state consistent if we need to open parent chains for nested items.
     */
    function setItemOpenImmediate(instance, head, shouldOpen) {
        if (!instance || !head) return;

        const contentWrapper = head.nextElementSibling;
        if (!isContentWrapperEl(contentWrapper)) return;

        // Ensure this belongs to this instance level
        if (!contentWrapperBelongsToInstance(instance, contentWrapper)) return;

        cancelPendingTransition(contentWrapper);

        // Temporarily disable transition so we don't animate on load
        const prevTransition = contentWrapper.style.transition;
        contentWrapper.style.transition = 'none';

        if (shouldOpen) {
            showContentWrapper(contentWrapper);
            contentWrapper.style.height = 'auto';
            setHeadActive(head, true);
        } else {
            hideContentWrapper(contentWrapper);
            setHeadActive(head, false);
        }

        // Force a reflow so "transition: none" takes effect before restoring
        contentWrapper.offsetHeight; // eslint-disable-line no-unused-expressions
        contentWrapper.style.transition = prevTransition || CONFIG.transitionCss;

        updateToggleAllText(instance);
    }

    /**
     * If a nested accordion item is opened initially, we must open its ancestors too,
     * otherwise the nested item is still hidden inside a closed parent.
     *
     * Strategy:
     * - Find the closest parent content wrapper (i.e., the container that hides/shows content)
     * - Its previous sibling should be the parent head
     * - Open that head immediately
     * - Repeat upward until no more parents exist
     */
    function openAncestorChainForHead(head) {
        let currentHead = head;

        while (currentHead) {
            const parentContentWrapper = currentHead.closest(CONFIG.contentWrapperSelector);
            if (!parentContentWrapper) break;

            const parentHead = parentContentWrapper.previousElementSibling;
            if (!parentHead || !parentHead.matches(CONFIG.headSelector)) break;

            const parentInstance = headToInstance.get(parentHead);
            if (!parentInstance) break;

            setItemOpenImmediate(parentInstance, parentHead, true);

            currentHead = parentHead;
        }
    }

    /**
     * Apply initial open rules for all instances.
     * Idempotent:
     * - Safe to run multiple times (rewire / dynamic injection).
     */
    function applyInitialOpenStates() {
        instances.forEach(function (instance) {
            if (!instance || !instance.wrapper) return;
            if (initialApplied.has(instance)) return;

            const wrapper = instance.wrapper;

            // Wrapper-level open-all wins
            const openAll = wrapperWantsOpenAll(wrapper);

            // Decide which heads should open in THIS wrapper
            const headsToOpen = [];

            if (openAll) {
                for (let i = 0; i < instance.heads.length; i += 1) headsToOpen.push(instance.heads[i]);
            } else {
                for (let i = 0; i < instance.items.length; i += 1) {
                    const item = instance.items[i];
                    const head = instance.heads[i];
                    if (!item || !head) continue;
                    if (itemWantsOpen(item, head)) headsToOpen.push(head);
                }
            }

            // Open ancestor chains first, then open targets
            // (order matters for nested accordions)
            for (let i = 0; i < headsToOpen.length; i += 1) {
                openAncestorChainForHead(headsToOpen[i]);
            }

            for (let j = 0; j < headsToOpen.length; j += 1) {
                setItemOpenImmediate(instance, headsToOpen[j], true);
            }

            // Mark as applied (rewire-safe)
            initialApplied.add(instance);

            updateToggleAllText(instance);

            if (CONFIG.debug && headsToOpen.length) {
                log('Applied initial open state:', {
                    wrapper: wrapper,
                    openAll: openAll,
                    openedCount: headsToOpen.length
                });
            }
        });
    }

    // ---------------------------------------------------------------------------
    // Helpers: ARIA + IDs (DRY)
    // ---------------------------------------------------------------------------

    function setWrapperAria(wrapper) {
        // This is optional but helps screen reader users understand the widget.
        wrapper.setAttribute(
            'aria-label',
            'Accordion: Use Tab to navigate, Enter or Space to toggle, Esc to close, and arrow keys to move between items.'
        );
    }

    function applyAriaToItem(head, contentWrapper, headId, contentId) {
        // Head (button-like)
        head.setAttribute('id', headId);
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.setAttribute('aria-controls', contentId);
        head.setAttribute('aria-expanded', 'false');

        // Content region
        contentWrapper.setAttribute('id', contentId);
        contentWrapper.setAttribute('role', 'region');
        contentWrapper.setAttribute('aria-labelledby', headId);
    }

    // ---------------------------------------------------------------------------
    // Helpers: state + UI
    // ---------------------------------------------------------------------------

    function isHeadActive(head) {
        return !!(head && head.classList.contains('is--active'));
    }

    function setHeadActive(head, active) {
        if (!head) return;
        if (active) {
            head.classList.add('is--active');
            head.setAttribute('aria-expanded', 'true');
        } else {
            head.classList.remove('is--active');
            head.setAttribute('aria-expanded', 'false');
        }
    }

    function updateToggleAllText(instance) {
        if (!instance || !instance.toggleAll) return;

        const title = instance.toggleAll.querySelector('.elementor-heading-title');
        if (!title) return;

        const allClosed = instance.heads.every(function (h) {
            return !isHeadActive(h);
        });

        title.textContent = allClosed ? 'Expand All' : 'Collapse All';
    }

    // ---------------------------------------------------------------------------
    // Helpers: transitions (DRY)
    // ---------------------------------------------------------------------------

    function cancelPendingTransition(contentWrapper) {
        if (!contentWrapper) return;

        const handler = pendingHandler.get(contentWrapper);
        if (handler) {
            contentWrapper.removeEventListener('transitionend', handler);
            pendingHandler.set(contentWrapper, null);
        }

        isTransitioning.set(contentWrapper, false);
    }

    function getContentHeightPx(contentWrapper) {
        const inner = getContentInnerForWrapper(contentWrapper);
        return inner ? inner.scrollHeight : 0;
    }

    function ensureOriginalDisplayCaptured(contentWrapper) {
        if (!contentWrapper) return;

        if (!originalDisplay.get(contentWrapper)) {
            const computed = window.getComputedStyle(contentWrapper).display;
            // If computed is "none" at init time, default to "block"
            originalDisplay.set(contentWrapper, computed && computed !== 'none' ? computed : 'block');
        }
    }

    function hideContentWrapper(contentWrapper) {
        if (!contentWrapper) return;
        contentWrapper.style.display = 'none';
        contentWrapper.style.height = '0px';
    }

    function showContentWrapper(contentWrapper) {
        if (!contentWrapper) return;
        ensureOriginalDisplayCaptured(contentWrapper);
        contentWrapper.style.display = originalDisplay.get(contentWrapper) || 'block';
    }

    function animateToHeight(contentWrapper, targetPx, onEnd) {
        if (!contentWrapper) return;

        cancelPendingTransition(contentWrapper);

        // Force transition style (in case theme overrides)
        contentWrapper.style.overflow = 'hidden';
        contentWrapper.style.transition = CONFIG.transitionCss;

        // Ensure we are animating from the current computed height
        // (When opening from display:none, we set height 0 then animate to full.)
        isTransitioning.set(contentWrapper, true);

        const handler = function () {
            contentWrapper.removeEventListener('transitionend', handler);
            pendingHandler.set(contentWrapper, null);
            isTransitioning.set(contentWrapper, false);

            if (typeof onEnd === 'function') onEnd();
        };

        pendingHandler.set(contentWrapper, handler);
        contentWrapper.addEventListener('transitionend', handler);

        contentWrapper.style.height = targetPx + 'px';
    }

    function openItem(instance, head) {
        const contentWrapper = head ? head.nextElementSibling : null;
        if (!isContentWrapperEl(contentWrapper)) return;

        // Ignore if this content does not belong to the instance’s top-level items
        if (!contentWrapperBelongsToInstance(instance, contentWrapper)) return;

        // If mid-transition, cancel and re-run cleanly
        cancelPendingTransition(contentWrapper);

        showContentWrapper(contentWrapper);

        // Start at 0, then animate to full height
        contentWrapper.style.height = '0px';
        // Force reflow to apply the starting height
        contentWrapper.offsetHeight; // eslint-disable-line no-unused-expressions

        const full = getContentHeightPx(contentWrapper);

        setHeadActive(head, true);

        animateToHeight(contentWrapper, full, function () {
            // Let it size naturally after open (better for responsive / dynamic content)
            contentWrapper.style.height = 'auto';
            updateToggleAllText(instance);
        });

        updateToggleAllText(instance);
    }

    function closeItem(instance, head) {
        const contentWrapper = head ? head.nextElementSibling : null;
        if (!isContentWrapperEl(contentWrapper)) return;

        if (!contentWrapperBelongsToInstance(instance, contentWrapper)) return;

        cancelPendingTransition(contentWrapper);

        // If currently auto, convert to numeric height first
        const full = getContentHeightPx(contentWrapper);
        showContentWrapper(contentWrapper);
        contentWrapper.style.height = full + 'px';
        contentWrapper.offsetHeight; // force reflow

        setHeadActive(head, false);

        animateToHeight(contentWrapper, 0, function () {
            hideContentWrapper(contentWrapper);
            updateToggleAllText(instance);
        });

        updateToggleAllText(instance);
    }

    // ---------------------------------------------------------------------------
    // Keyboard support (per wrapper, but listeners are per-head, not global)
    // ---------------------------------------------------------------------------

    function bindHeadKeyboard(instance, head, index) {
        head.addEventListener('keydown', function (event) {
            const key = event.key;
            const isHandled =
                key === 'Enter' ||
                key === ' ' ||
                key === 'Escape' ||
                key === 'ArrowDown' ||
                key === 'ArrowUp' ||
                key === 'Home' ||
                key === 'End';

            if (!isHandled) return;

            event.preventDefault();
            event.stopPropagation();

            if (key === 'Enter' || key === ' ') {
                isHeadActive(head) ? closeItem(instance, head) : openItem(instance, head);
                return;
            }

            if (key === 'Escape') {
                if (isHeadActive(head)) closeItem(instance, head);
                head.focus();
                return;
            }

            if (key === 'ArrowDown') {
                (instance.heads[index + 1] || instance.heads[0]).focus();
                return;
            }

            if (key === 'ArrowUp') {
                (instance.heads[index - 1] || instance.heads[instance.heads.length - 1]).focus();
                return;
            }

            if (key === 'Home') {
                instance.heads[0].focus();
                return;
            }

            if (key === 'End') {
                instance.heads[instance.heads.length - 1].focus();
            }
        });
    }

    // ---------------------------------------------------------------------------
    // Singleton: Escape handler (ONE listener for the whole page)
    // ---------------------------------------------------------------------------

    let escapeHandlerBound = false;

    function bindGlobalEscapeHandlerOnce() {
        if (escapeHandlerBound) return;
        escapeHandlerBound = true;

        document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') return;

            const active = document.activeElement;
            if (!active) return;

            const wrapper = active.closest(CONFIG.wrapperSelector);
            if (!wrapper) return;

            const instance = instances.get(wrapper);
            if (!instance) return;

            // Close only if focus is within THIS wrapper’s level and an item is open
            // We check:
            // - focused element inside a top-level contentWrapper OR head
            // - AND head is active
            for (let i = 0; i < instance.items.length; i += 1) {
                const item = instance.items[i];
                const head = instance.heads[i];
                const contentWrapper = getContentWrapperForItem(item);

                if (!head || !contentWrapper) continue;
                if (!contentWrapperBelongsToInstance(instance, contentWrapper)) continue;

                const focusWithinThisItem =
                    head === active ||
                    contentWrapper.contains(active);

                if (!focusWithinThisItem) continue;

                if (isHeadActive(head)) {
                    closeItem(instance, head);
                    head.focus();
                    event.stopPropagation();
                }

                return;
            }
        });
    }

    // ---------------------------------------------------------------------------
    // Singleton: ResizeObserver (ONE observer for the whole page)
    // ---------------------------------------------------------------------------

    let sharedResizeObserver = null;

    function ensureResizeObserverOnce() {
        if (sharedResizeObserver) return sharedResizeObserver;

        sharedResizeObserver = new ResizeObserver(function (entries) {
            entries.forEach(function (entry) {
                const contentInner = entry.target;
                const contentWrapper = wrapperByInner.get(contentInner);
                if (!contentWrapper) return;

                // If wrapper is open and not transitioning, keep height correct
                const head = contentWrapper.previousElementSibling;
                if (!head) return;

                // If open panels use height:auto, no action needed.
                // If during/after transitions, it might be numeric; keep it stable.
                if (isHeadActive(head) && !isTransitioning.get(contentWrapper)) {
                    // If height is auto, leave it alone.
                    // If numeric, recalc. This helps when inner content loads images etc.
                    const current = String(contentWrapper.style.height || '');
                    if (current && current !== 'auto') {
                        const full = getContentHeightPx(contentWrapper);
                        contentWrapper.style.height = full + 'px';
                    }
                }
            });
        });

        return sharedResizeObserver;
    }

    // ---------------------------------------------------------------------------
    // Init per wrapper
    // ---------------------------------------------------------------------------

    function initAccordionWrapper(wrapper) {
        if (!wrapper || !(wrapper instanceof HTMLElement)) return;
        if (wrapper.getAttribute(CONFIG.readyAttr) === '1') return;

        const wrapperUid = wrapperUidCounter;
        wrapperUidCounter += 1;

        setWrapperAria(wrapper);

        const items = getTopLevelItems(wrapper);
        const heads = items
            .map(function (item) { return getHeadForItem(item); })
            .filter(Boolean);

        const toggleAll = getToggleAllForWrapper(wrapper);

        if (toggleAll && toggleAll.tagName !== 'BUTTON' && toggleAll.tagName !== 'A') {
            toggleAll.setAttribute('role', 'button');
            toggleAll.setAttribute('tabindex', '0');
        }

        // Store instance
        const instance = {
            uid: wrapperUid,
            wrapper: wrapper,
            items: items,
            heads: heads,
            toggleAll: toggleAll
        };

        // Wire items: ARIA IDs, initial styles, transition bookkeeping, ResizeObserver mapping
        items.forEach(function (item, index) {
            const head = getHeadForItem(item);
            const contentWrapper = getContentWrapperForItem(item);
            const contentInner = contentWrapper ? contentWrapper.querySelector(':scope > ' + CONFIG.contentInnerSelector) : null;

            if (!head || !contentWrapper || !contentInner) return;

            const headId = 'kcss-accordion-head-' + wrapperUid + '-' + index;
            const contentId = 'kcss-accordion-content-' + wrapperUid + '-' + index;

            headToInstance.set(head, instance);

            applyAriaToItem(head, contentWrapper, headId, contentId);

            // Capture original display once, then collapse closed by default
            ensureOriginalDisplayCaptured(contentWrapper);

            // Initial closed state
            contentWrapper.style.overflow = 'hidden';
            contentWrapper.style.transition = CONFIG.transitionCss;
            hideContentWrapper(contentWrapper);
            setHeadActive(head, false);

            // Track inner mapping for height measurement and ResizeObserver
            contentInnerByWrapper.set(contentWrapper, contentInner);
            wrapperByInner.set(contentInner, contentWrapper);

            // Observe inner resizes (singleton observer)
            ensureResizeObserverOnce().observe(contentInner);
        });

        // Click behavior (per head)
        heads.forEach(function (head, index) {
            head.addEventListener('click', function (e) {
                // Prevent bubbling to avoid nested accordion interference
                e.stopPropagation();

                if (isHeadActive(head)) closeItem(instance, head);
                else openItem(instance, head);
            });

            bindHeadKeyboard(instance, head, index);
        });

        // Toggle-all behavior (optional)
        if (toggleAll) {
            toggleAll.addEventListener('click', function (e) {
                e.stopPropagation();

                const shouldExpand = instance.heads.every(function (h) {
                    return !isHeadActive(h);
                });

                log('Toggle-all clicked. shouldExpand=', shouldExpand, 'wrapperUid=', wrapperUid);

                instance.heads.forEach(function (head) {
                    if (shouldExpand) openItem(instance, head);
                    else closeItem(instance, head);
                });
            });

            toggleAll.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleAll.click();
                }
            });
        }

        // Mark ready + register instance
        wrapper.setAttribute(CONFIG.readyAttr, '1');
        instances.set(wrapper, instance);

        updateToggleAllText(instance);
        log('Initialized accordion wrapper:', wrapper, 'uid=', wrapperUid);
    }

    // ---------------------------------------------------------------------------
    // Init all (safe to call repeatedly)
    // ---------------------------------------------------------------------------

    function initAllAccordions() {
        bindGlobalEscapeHandlerOnce();
        ensureResizeObserverOnce();

        const wrappers = document.querySelectorAll(CONFIG.wrapperSelector);
        for (let i = 0; i < wrappers.length; i += 1) {
            initAccordionWrapper(wrappers[i]);
        }

        applyInitialOpenStates();
    }

    // ---------------------------------------------------------------------------
    // Public API (optional)
    // ---------------------------------------------------------------------------

    window.KCSS_Accordion = {
        setDebug: function (val) {
            CONFIG.debug = !!val;
        },
        rewire: function () {
            // Allows manual re-init after dynamic injections
            initAllAccordions();
        }
    };

    // ---------------------------------------------------------------------------
    // Boot
    // ---------------------------------------------------------------------------
    initAllAccordions();
});

//V2
runIfElementExists('.kcss_carousel', () => {
    console.log('kcss carousel init');

    window.addEventListener('load', () => {
        const swipers = document.querySelectorAll(
            '.kcss_carousel .swiper, .kcss_carousel .swiper-container'
        );

        // Check if any carousel declares kcss-swiper-mousewheel
        const needsMousewheel = [...swipers].some(swiperEl => {
            const parent = swiperEl.closest('.kcss_carousel');
            return parent?.hasAttribute('kcss-swiper-mousewheel');
        });

        if (needsMousewheel && Swiper?.use && Swiper?.Mousewheel) {
            console.log('Registering Swiper Mousewheel module');
            Swiper.use([Swiper.Mousewheel]);
        }

        let attempts = 0;
        const interval = setInterval(() => {
            try {
                initKcssCarousels();
                attempts++;

                const anyInitialized = [...swipers].some(swiperEl =>
                    swiperEl.swiper && swiperEl.swiper.initialized
                );

                if (anyInitialized || attempts > 30) {
                    clearInterval(interval);
                    if (attempts > 30) console.log('Swiper not found');
                }
            } catch (err) {
                console.log(err);
            }
        }, 100);
    });

    function initKcssCarousels() {
        if (document.querySelector('.elementor-editor-active')) {
            return; // don’t run in Elementor editor mode
        }

        const swipers = document.querySelectorAll(
            '.kcss_carousel .swiper, .kcss_carousel .swiper-container'
        );

        swipers.forEach(swiperEl => {
            const parent = swiperEl.closest('.kcss_carousel');
            const swiperInstance = swiperEl.swiper;
            const currentParams = swiperInstance.params;

            const newParams = {
                ...currentParams,
                on: {
                    ...currentParams.on,
                    init() {
                        this.slides.forEach(slide => {
                            slide.removeAttribute('inert');
                            slide.removeAttribute('aria-hidden');
                        });
                    }
                }
            };

            // Apply all kcss-swiper-* attributes
            const overrides = getSwiperOverridesFromData(parent);

            // If kcss-swiper-mousewheel is present, hardcode mousewheel config
            if (parent?.hasAttribute('kcss-swiper-mousewheel')) {
                overrides.mousewheel = {
                    enabled: true,
                    forceToAxis: true,
                    releaseOnEdges: false
                };
            }

            Object.assign(newParams, overrides);

            swiperInstance.destroy();
            new Swiper(swiperEl, newParams);
        });
    }

    /**
     * Reads kcss-swiper-* attributes, converts to camelCase keys, parses values.
     */
    function getSwiperOverridesFromData(el) {
        const result = {};
        for (const attr of el.attributes) {
            if (!attr.name.startsWith('kcss-swiper-')) continue;

            const key = attr.name
                .replace('kcss-swiper-', '')
                .split('-')
                .map((part, index) =>
                    index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
                )
                .join('');

            result[key] = parseValue(attr.value);
        }
        return result;
    }

    /**
     * Parses value as number, boolean, or string.
     */
    function parseValue(value) {
        try {
            return JSON.parse(value);
        } catch {
            if (value === 'true') return true;
            if (value === 'false') return false;
            if (!isNaN(value) && value.trim() !== '') return Number(value);
            return value;
        }
    }
});

// Escape key handler for elementor lightbox/off-canvas keyboard input conflict resolution
document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;

        const lightbox = document.querySelector(
            '.dialog-widget.dialog-lightbox-widget.elementor-lightbox'
        );

        const offCanvasOpen = document.querySelector(
            '.e-off-canvas[aria-hidden="false"]'
        );

        if (offCanvasOpen && lightbox && lightbox.style.display !== 'none') {
            console.log('Lightbox is open — suppress off-canvas ESC handler');
            e.stopImmediatePropagation();
        }
    });
});

// Gallery navigation management for off-canvas galleries
document.addEventListener('DOMContentLoaded', function() {
    const galleryPairs = []; // { gallery, navTarget, galleryWidget }

    function scrollGalleryIntoView(pair) {
        const { galleryWidget } = pair;
        const scrollContainer = galleryWidget.closest('.e-off-canvas__content');
        const headerOffset = 120;

        if (!scrollContainer) {
            console.warn('No scrollContainer found');
            return;
        }

        setTimeout(function() {
            const elementPosition = galleryWidget.offsetTop;
            const offsetPosition = Math.max(elementPosition - headerOffset, 0);

            console.log('Scrolling to gallery:', {
                elementPosition,
                offsetPosition,
                headerOffset
            });

            scrollContainer.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }, 100);
    }

    function hideOriginalButton(btn) {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-hidden', 'true');
    }

    function createButtonClone(btn, pair) {
        const clone = btn.cloneNode(true);
        clone.setAttribute('tabindex', '0');
        clone.setAttribute('aria-hidden', 'false');

        function handleActivation(e) {
            e.preventDefault();
            btn.click();
            scrollGalleryIntoView(pair);
        }

        clone.addEventListener('click', handleActivation);

        clone.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                handleActivation(e);
            }
        });

        return clone;
    }

    function syncButtonStates(navTarget, cloneMap) {
        cloneMap.forEach(function(clone, original) {
            if (original.classList.contains('elementor-item-active')) {
                clone.classList.add('elementor-item-active');
            } else {
                clone.classList.remove('elementor-item-active');
            }
        });
    }

    function setupGallery(gallery) {
        const navTarget = gallery.querySelector('.kcss-gallery-navigation-target');
        const galleryWidget = gallery.querySelector('.elementor-widget-gallery');

        if (!navTarget || !galleryWidget) {
            console.warn('Gallery or navigation missing for', gallery);
            return;
        }

        // Check if gallery is actually inside an off-canvas before proceeding
        const scrollContainer = galleryWidget.closest('.e-off-canvas__content');
        if (!scrollContainer) {
            console.warn('Gallery is not inside an off-canvas container, skipping setup');
            return;
        }

        const originalContainer = gallery.querySelector('.elementor-gallery__titles-container');
        if (!originalContainer) {
            console.warn('Gallery filters not found in', gallery);
            return;
        }

        const pair = { gallery, navTarget, galleryWidget };
        const originalButtons = [...originalContainer.querySelectorAll('.elementor-item')];
        const cloneMap = new Map();

        // Clone buttons
        navTarget.innerHTML = '';

        originalButtons.forEach(function(btn) {
            hideOriginalButton(btn);
            const clone = createButtonClone(btn, pair);
            navTarget.appendChild(clone);
            cloneMap.set(btn, clone);
        });

        // Setup mutation observer to sync active states
        const observer = new MutationObserver(function() {
            syncButtonStates(navTarget, cloneMap);
        });

        observer.observe(originalContainer, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
        });

        gallery.classList.add('kcss-gallery-filters-cloned');
        galleryPairs.push(pair);
    }

    // Only initialize galleries that are inside off-canvas containers OR have the custom attribute
    document.querySelectorAll('.kcss-off-canvas-gallery').forEach(function(gallery) {
        // Option 1: Check if it's inside an off-canvas
        const isInsideOffCanvas = gallery.closest('.e-off-canvas');

        // Option 2: OR check for custom attribute (if you want to add one)
        const hasCustomAttribute = gallery.hasAttribute('data-off-canvas-gallery');

        if (isInsideOffCanvas || hasCustomAttribute) {
            setupGallery(gallery);
        } else {
            console.log('Gallery not in off-canvas context, skipping:', gallery);
        }
    });
});

/**
 * KCSS Elementor Off-Canvas Controller
 * ===================================
 *
 * Why this exists
 * ---------------
 * Elementor Off-Canvas widgets are normally triggered by Elementor-generated links.
 * Those links contain a special hash URL:
 *   #elementor-action:action=off_canvas:<open|close>&settings=<base64-json>
 *
 * In real-world builds (templates, global footer off-canvas, archive ajax, etc.),
 * teams often need a consistent way to wire custom triggers without hunting IDs
 * in the DOM each time.
 *
 * This script:
 * - Allows off-canvas to be targeted by either:
 *    A) OFF-CANVAS NAME (aria-label)
 *    B) INTERNAL ELEMENTOR ID (backwards compatible with older projects)
 * - Supports open / close / toggle
 * - Re-wires triggers after dynamic content updates (archive)
 * - Provides optional debug logging
 *
 * Dependencies / assumptions (important)
 * -------------------------------------
 * 1) Elementor outputs off-canvas markup like:
 *      <section class="e-off-canvas" id="off-canvas-ad15b05" aria-label="Video" ...>
 *
 * 2) Elementor routes the “elementor-action” hash links client-side.
 *    If Elementor changes that internal routing format, only buildActionHref()
 *    should need to change (DRY principle).
 *
 * 3) For name-based targeting, aria-label should be unique per page.
 *    If you reuse the same aria-label on multiple off-canvas widgets, the first match wins.
 *
 * What breaks if you remove pieces
 * -------------------------------
 * - Remove setupOffCanvasTriggers(): your triggers won’t get wired with hrefs.
 * - Remove bindToggleDelegation(): toggle buttons won’t work (toggle needs runtime logic).
 * - Remove archive hooks: dynamically injected content may not be wired.
 * - Remove off-canvas mount observer: if Elementor injects the off-canvas later, name-based
 *   resolution might fail on first pass.
 *
 * Debugging
 * ---------
 * Run in console:
 *   KCSS_OffCanvas.setDebug(true)
 */

(() => {
    // ---------------------------------------------------------------------------
    // Configuration
    // ---------------------------------------------------------------------------
    const CONFIG = {
        debug: false,

        // Elementor Off-Canvas root section selector
        offCanvasSelector: '.e-off-canvas',

        // --------------------
        // NEW (recommended): Name-based attributes (aria-label matching)
        // --------------------
        attrOpenByName: 'data-kcss-offcanvas-open',
        attrCloseByName: 'data-kcss-offcanvas-close',
        attrToggleByName: 'data-kcss-offcanvas-toggle',

        // --------------------
        // LEGACY: ID-based attributes (internal elementor ID, e.g. "ad15b05")
        // --------------------
        attrOpenByIdLegacy: 'data-kcss-offcanvas',          // existing usage: open
        attrCloseByIdLegacy: 'data-kcss-offcanvas-close-id',
        attrToggleByIdLegacy: 'data-kcss-offcanvas-toggle-id',

        // Archive integration (optional; keep if you inject/restore content dynamically)
        archiveRootSelector: '#kam_archive',
        archiveEventName: 'archive_request_complete',

        // Cross-page intent support (optional; leave if you use it)
        crossPageWrapperSelector: '.js-open-offcanvas',
        storageKey: 'kcss_offcanvas_intent',
        maxRafTries: 120,

        // Animation reliability helper:
        // When true, we try to click an existing Elementor-generated trigger (if present)
        // because that path often applies internal animation handling more consistently.
        preferNativeElementorTrigger: true
    };

    // ---------------------------------------------------------------------------
    // Debug logger (kept tiny + low overhead)
    // ---------------------------------------------------------------------------
    function log() {
        if (!CONFIG.debug) return;
        console.log.apply(console, ['[KCSS OffCanvas]'].concat([].slice.call(arguments)));
    }
    function warn() {
        if (!CONFIG.debug) return;
        console.warn.apply(console, ['[KCSS OffCanvas]'].concat([].slice.call(arguments)));
    }

    // ---------------------------------------------------------------------------
    // Normalisation helpers
    // ---------------------------------------------------------------------------

    /**
     * Normalise a “name” to minimise user-error (extra spaces, line breaks).
     * We DO NOT force lowercase by default because aria-label matching is exact.
     * If you want case-insensitive matching, we can add .toLowerCase() in both
     * normaliseName() and the lookup.
     */
    function normaliseName(name) {
        return String(name || '').trim().replace(/\s+/g, ' ');
    }

    /**
     * Internal Elementor ID normaliser.
     * Devs sometimes pass "off-canvas-ad15b05" by mistake; we strip the prefix.
     */
    function normaliseElementorId(id) {
        const raw = String(id || '').trim();
        if (!raw) return '';
        return raw.replace(/^off-canvas-/, '');
    }

    /*
     * Given a list of Elementor trigger <a> elements (same aria-controls),
     * choose the most appropriate one for the desired mode.
     *
     * Why this exists:
     * - Elementor often outputs multiple triggers for the same off-canvas (open + close).
     * - We want one DRY place to apply the selection rules.
     *
     * Robustness:
     * - Elementor may URL-encode href attributes, so we look for BOTH:
     *     ":open" / ":close"
     *   and "%3aopen" / "%3aclose"
     */
    function pickTriggerForMode(nodeList, desiredMode /* "open"|"close"|"" */) {
        if (!nodeList || !nodeList.length) return null;

        // Default: first matching trigger
        let chosen = nodeList[0];

        // Only special-case open/close (toggle etc. can just click first)
        if (desiredMode === 'open' || desiredMode === 'close') {
            const want = desiredMode.toLowerCase();

            for (let i = 0; i < nodeList.length; i += 1) {
                const h = String(nodeList[i].getAttribute('href') || '').toLowerCase();

                // Works for both encoded and unencoded href attributes
                if (h.indexOf('%3a' + want) !== -1 || h.indexOf(':' + want) !== -1) {
                    chosen = nodeList[i];
                    break;
                }
            }
        }

        return chosen;
    }

    // ---------------------------------------------------------------------------
    // Off-canvas resolution (kept as separate functions for clean future removal)
    // ---------------------------------------------------------------------------

    /**
     * Resolve an off-canvas section by NAME (aria-label).
     * This is the “client-friendly” targeting mode.
     */

    function findOffCanvasByName(name) {
        const target = normaliseName(name);
        if (!target) return null;

        // Fast path (exact match)
        const exact = document.querySelector(
            CONFIG.offCanvasSelector + '[aria-label="' + CSS.escape(target) + '"]'
        );
        if (exact) return exact;

        // Fallback (normalised whitespace match)
        const all = document.querySelectorAll(CONFIG.offCanvasSelector + '[aria-label]');
        for (const el of all) {
            const label = normaliseName(el.getAttribute('aria-label'));
            if (label === target) return el;
        }
        return null;
    }

    /**
     * Resolve an off-canvas section by internal Elementor ID.
     * ID format: section id="off-canvas-<elementorId>"
     */
    function findOffCanvasByElementorId(elementorId) {
        const id = normaliseElementorId(elementorId);
        if (!id) return null;
        return document.getElementById('off-canvas-' + id);
    }

    /**
     * Extract internal elementorId from an off-canvas <section>.
     * Keeps ID parsing DRY in one place.
     */
    function extractElementorIdFromOffCanvasSection(sectionEl) {
        const rawId = sectionEl && sectionEl.id ? sectionEl.id : '';
        const match = rawId.match(/^off-canvas-(.+)$/);
        return match ? match[1] : null;
    }

    /**
     * Convert name -> elementorId (name resolver uses DOM lookup then ID extraction).
     */
    function resolveElementorIdFromName(name) {
        const offCanvas = findOffCanvasByName(name);
        if (!offCanvas) return null;
        return extractElementorIdFromOffCanvasSection(offCanvas);
    }

    // ---------------------------------------------------------------------------
    // Elementor Action URL builder (single source of truth)
    // ---------------------------------------------------------------------------

    /**
     * Builds the hash URL Elementor uses internally.
     * This is intentionally the *only* place that “knows” the format.
     *
     * If Elementor changes the action URL format in future, update here.
     */
    function buildActionHref(elementorId, mode /* "open" | "close" */) {
        const id = normaliseElementorId(elementorId);
        if (!id) return '';

        const settings = { id: id, displayMode: mode };
        const encoded = btoa(JSON.stringify(settings));
        return '#elementor-action:action=off_canvas:' + mode + '&settings=' + encoded;
    }

    // ---------------------------------------------------------------------------
    // Trigger wiring utilities
    // ---------------------------------------------------------------------------

    /**
     * Apply a built href to an element.
     * Supports:
     * - <a ...> triggers directly
     * - wrapper triggers that contain a child <a>
     *
     * If removed: many Elementor layouts (container-as-link) won’t get wired.
     */
    function applyHrefToTrigger(triggerEl, href) {
        const link = triggerEl.tagName === 'A' ? triggerEl : triggerEl.querySelector('a');
        if (!link) return false;

        link.setAttribute('href', href);
        link.setAttribute('data-kcss-offcanvas-ready', '1');
        return true;
    }

    /**
     * Optional: click a native Elementor-generated trigger if one exists for this off-canvas.
     * Why this exists:
     * - Some Elementor behaviours (including animation classes / internal state tracking)
     *   appear to be more consistent when the click originates from a native trigger.
     *
     * If none exists, we fall back to a temporary <a> click using the action URL.
     */
    function tryClickNativeElementorTrigger(elementorId, mode) {
        if (!CONFIG.preferNativeElementorTrigger) return false;

        // This helper is for open/close reliability; toggle should remain state-based.
        if (mode === 'toggle') return false;

        const controls = 'off-canvas-' + normaliseElementorId(elementorId);

        // IMPORTANT: do not filter by href in selector (href may be URL-encoded)
        const triggers = document.querySelectorAll('a[aria-controls="' + CSS.escape(controls) + '"]');
        if (!triggers || !triggers.length) return false;

        const chosen = pickTriggerForMode(triggers, mode);
        if (!chosen) return false;

        log('Clicking native Elementor trigger for animation reliability:', chosen);
        chosen.click();
        return true;
    }

    /**
     * Fallback: create a temporary link with the action URL and click it.
     * This is the most universal way to trigger Elementor’s router without needing
     * a pre-existing trigger element.
     */
    function clickViaTemporaryActionLink(elementorId, mode) {
        const href = buildActionHref(elementorId, mode);
        if (!href) return false;

        const tmp = document.createElement('a');
        tmp.href = href;
        tmp.style.display = 'none';
        document.body.appendChild(tmp);

        log('Clicking temporary action link:', href);
        tmp.click();
        tmp.remove();

        return true;
    }

    /**
     * Execute open/close by elementorId with native-trigger preference fallback.
     */
    function executeActionById(elementorId, mode /* open|close */) {
        const id = normaliseElementorId(elementorId);
        if (!id) return false;

        // Prefer native trigger if configured and available
        if (tryClickNativeElementorTrigger(id, mode)) return true;

        // Otherwise, use action-link fallback
        return clickViaTemporaryActionLink(id, mode);
    }

    // ---------------------------------------------------------------------------
    // Wiring functions (kept separate for easy legacy removal later)
    // ---------------------------------------------------------------------------

    function wireTriggerByName(triggerEl, name, mode /* open|close */) {
        const elementorId = resolveElementorIdFromName(name);
        if (!elementorId) {
            warn('No off-canvas found for name="' + name + '" (mode=' + mode + ').', triggerEl);
            return;
        }

        const href = buildActionHref(elementorId, mode);
        if (!href) {
            warn('Failed to build href for name="' + name + '" (id=' + elementorId + ').');
            return;
        }

        const ok = applyHrefToTrigger(triggerEl, href);
        if (ok) log('Wired ' + mode + ' by NAME "' + name + '" -> id=' + elementorId, triggerEl);
        else warn('Trigger found but no <a> to apply href.', triggerEl);
    }

    function wireTriggerById(triggerEl, elementorId, mode /* open|close */) {
        const id = normaliseElementorId(elementorId);
        if (!id) {
            warn('Missing/invalid elementorId for ' + mode + ' trigger.', triggerEl);
            return;
        }

        const href = buildActionHref(id, mode);
        const ok = applyHrefToTrigger(triggerEl, href);

        if (ok) log('Wired ' + mode + ' by ID "' + id + '"', triggerEl);
        else warn('Trigger found but no <a> to apply href.', triggerEl);
    }

    // ---------------------------------------------------------------------------
    // Setup open/close triggers (href wiring)
    // ---------------------------------------------------------------------------

    /**
     * Toggle cannot be wired via static href because it must decide open vs close
     * at the moment of click (based on current aria-hidden state).
     *
     * Therefore:
     * - open/close => wired by href
     * - toggle     => handled by event delegation below
     */
    function setupOffCanvasTriggers() {
        // --- NEW (name-based): open
        {
            const nodes = document.querySelectorAll('[' + CONFIG.attrOpenByName + ']');
            for (const el of nodes) {
                const name = normaliseName(el.getAttribute(CONFIG.attrOpenByName));
                if (!name) continue;
                wireTriggerByName(el, name, 'open');
            }
        }

        // --- NEW (name-based): close
        {
            const nodes = document.querySelectorAll('[' + CONFIG.attrCloseByName + ']');
            for (const el of nodes) {
                const name = normaliseName(el.getAttribute(CONFIG.attrCloseByName));
                if (!name) continue;
                wireTriggerByName(el, name, 'close');
            }
        }

        // --- LEGACY (id-based): open
        {
            const nodes = document.querySelectorAll('[' + CONFIG.attrOpenByIdLegacy + ']');
            for (const el of nodes) {
                const id = normaliseElementorId(el.getAttribute(CONFIG.attrOpenByIdLegacy));
                if (!id) continue;
                wireTriggerById(el, id, 'open');
            }
        }

        // --- LEGACY (id-based): close
        {
            const nodes = document.querySelectorAll('[' + CONFIG.attrCloseByIdLegacy + ']');
            for (const el of nodes) {
                const id = normaliseElementorId(el.getAttribute(CONFIG.attrCloseByIdLegacy));
                if (!id) continue;
                wireTriggerById(el, id, 'close');
            }
        }

        log('Trigger wiring complete.');
    }

    // ---------------------------------------------------------------------------
    // Toggle support (event delegation)
    // ---------------------------------------------------------------------------

    /**
     * Determine whether an off-canvas is currently open.
     * Elementor uses aria-hidden:
     *   aria-hidden="false" => open
     *   aria-hidden="true"  => closed
     */
    function isOffCanvasOpen(offCanvasEl) {
        if (!offCanvasEl) return false;
        return offCanvasEl.getAttribute('aria-hidden') === 'false';
    }

    /**
     * Handle toggle click for name-based triggers.
     * This resolves the off-canvas element, checks current open state, then runs open/close.
     */
    function handleToggleByName(name) {
        const offCanvas = findOffCanvasByName(name);
        if (!offCanvas) return false;

        const elementorId = extractElementorIdFromOffCanvasSection(offCanvas);
        if (!elementorId) return false;

        const mode = isOffCanvasOpen(offCanvas) ? 'close' : 'open';
        log('Toggle by NAME "' + name + '" => ' + mode + ' (id=' + elementorId + ')');

        return executeActionById(elementorId, mode);
    }

    /**
     * Handle toggle click for id-based triggers.
     */
    function handleToggleById(elementorId) {
        const offCanvas = findOffCanvasByElementorId(elementorId);
        // If not found, we can still attempt to execute open (fallback)
        // but toggle requires state, so we need the element to read aria-hidden.
        if (!offCanvas) return false;

        const id = normaliseElementorId(elementorId);
        const mode = isOffCanvasOpen(offCanvas) ? 'close' : 'open';
        log('Toggle by ID "' + id + '" => ' + mode);

        return executeActionById(id, mode);
    }

    /**
     * Event delegation for toggles.
     * Why delegation:
     * - Works for dynamically inserted content
     * - Keeps listeners minimal (DRY + efficient)
     */
    function bindToggleDelegation() {
        document.addEventListener(
            'click',
            function (e) {
                // Name-based toggle
                const nameNode = e.target.closest('[' + CONFIG.attrToggleByName + ']');
                if (nameNode) {
                    // Respect normal browser behaviour on <a> (new tab etc.) unless it's a plain left-click
                    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

                    const name = normaliseName(nameNode.getAttribute(CONFIG.attrToggleByName));
                    if (!name) return;

                    e.preventDefault();
                    const ok = handleToggleByName(name);
                    if (!ok) warn('Toggle by NAME failed for:', name, nameNode);
                    return;
                }

                // Legacy ID-based toggle
                const idNode = e.target.closest('[' + CONFIG.attrToggleByIdLegacy + ']');
                if (idNode) {
                    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

                    const id = normaliseElementorId(idNode.getAttribute(CONFIG.attrToggleByIdLegacy));
                    if (!id) return;

                    e.preventDefault();
                    const ok = handleToggleById(id);
                    if (!ok) warn('Toggle by ID failed for:', id, idNode);
                }
            },
            true // capture helps when Elementor stops propagation in widgets
        );
    }

    // ---------------------------------------------------------------------------
    // Dynamic content support (archive + off-canvas mount)
    // ---------------------------------------------------------------------------

    function bindArchiveEventHook() {
        document.addEventListener(CONFIG.archiveEventName, function () {
            log(CONFIG.archiveEventName + ' detected -> re-wiring triggers.');
            setupOffCanvasTriggers();
        });
    }

    function bindArchiveMutationHook() {
        const archiveElement = document.querySelector(CONFIG.archiveRootSelector);
        if (!archiveElement || !archiveElement.parentElement) return;

        const parent = archiveElement.parentElement;

        const observer = new MutationObserver(function (mutations) {
            for (const m of mutations) {
                if (m.type === 'childList' && m.addedNodes && m.addedNodes.length > 0) {
                    log('Archive updated via MutationObserver -> re-wiring triggers.');
                    setupOffCanvasTriggers();
                    break;
                }
            }
        });

        observer.observe(parent, { childList: true, subtree: false });
        log('Observing archive parent for updates:', parent);
    }

    /**
     * Watches for late-inserted off-canvas elements.
     * Why:
     * - If the off-canvas is injected after DOMContentLoaded, name-based resolution
     *   could fail until it appears. When we detect it, we rewire triggers.
     *
     * What could break if removed:
     * - Some template/async scenarios may require a manual rewire.
     */
    function bindOffCanvasMountObserver() {
        const mountObs = new MutationObserver(function (mutations) {
            for (const m of mutations) {
                if (!m.addedNodes || !m.addedNodes.length) continue;

                for (const node of m.addedNodes) {
                    if (!(node instanceof HTMLElement)) continue;

                    const found =
                        (node.matches && node.matches(CONFIG.offCanvasSelector)) ||
                        (node.querySelector && node.querySelector(CONFIG.offCanvasSelector));

                    if (found) {
                        log('Detected off-canvas mount/injection -> re-wiring triggers.');
                        setupOffCanvasTriggers();
                        return;
                    }
                }
            }
        });

        mountObs.observe(document.body, { childList: true, subtree: true });
    }

    function bindCrossPageCapture() {
        document.addEventListener(
            'click',
            function (e) {
                const wrapperOrLink = e.target.closest(CONFIG.crossPageWrapperSelector);
                if (!wrapperOrLink) return;

                const link = wrapperOrLink.tagName === 'A' ? wrapperOrLink : e.target.closest('a');
                if (!link) return;

                // Respect normal browser behavior (new tab, modifiers, etc.)
                if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

                const href = link.getAttribute('href');
                if (!href) {
                    if (CONFIG.debug) warn('Cross-page: no href on link; intent not stored.', link);
                    return;
                }

                // Only store intent for same-origin navigation
                let url;
                try {
                    url = new URL(href, location.href);
                } catch (err) {
                    if (CONFIG.debug) warn('Cross-page: invalid URL; intent not stored.', href, err);
                    return;
                }

                // if (url.origin !== location.origin) return;

                if (url.origin !== location.origin) {
                    if (CONFIG.debug) warn('Cross-page: origin mismatch; intent not stored.', {
                        from: location.origin,
                        to: url.origin,
                        href: href
                    });
                    return;
                }

                // Legacy controls (old behavior): data-offcanvas="off-canvas-xxxxx"
                const controls = String(link.dataset.offcanvas || '').trim();

                // Name-based: data-kcss-offcanvas-name="Video" (or data-offcanvas-name)
                const name = normaliseName(link.dataset.kcssOffcanvasName || link.dataset.offcanvasName || '');

                // Optional mode (defaults to open)
                const modeAttr = String(link.dataset.kcssOffcanvasMode || link.dataset.offcanvasMode || '')
                    .trim()
                    .toLowerCase();

                let mode = 'open';
                if (modeAttr === 'close') mode = 'close';
                else if (modeAttr === 'toggle') mode = 'toggle';

                if (!controls && !name) {
                    if (CONFIG.debug) warn('Cross-page: no controls or name; intent not stored.', link);
                    return;
                }

                // DRY payload: only store mode if not default
                const intent = { controls: controls || null, name: name || null };
                if (mode !== 'open') intent.mode = mode;

                try {
                    sessionStorage.setItem(CONFIG.storageKey, JSON.stringify(intent));
                    if (CONFIG.debug) log('Stored cross-page off-canvas intent:', intent);
                } catch (err) {
                    if (CONFIG.debug) warn('Cross-page: sessionStorage failed; intent not stored.', err);
                }
            },
            true
        );
    }

    function autoExecuteIntentOnDestination() {
        const execute = function () {
            const raw = sessionStorage.getItem(CONFIG.storageKey);
            if (!raw) return; // early exit

            let intent;
            try {
                intent = JSON.parse(raw);
            } catch (err) {
                if (CONFIG.debug) warn('Destination: invalid intent JSON; aborting.', err);
                return;
            }

            const modeRaw = String(intent.mode || 'open').toLowerCase();
            let mode = 'open';
            if (modeRaw === 'close') mode = 'close';
            else if (modeRaw === 'toggle') mode = 'toggle';

            const storedControls = String(intent.controls || '').trim(); // "off-canvas-xxxxx"
            const storedName = normaliseName(intent.name || '');

            if (CONFIG.debug) {
                log('Destination intent received:', {
                    mode: mode,
                    controls: storedControls || null,
                    name: storedName || null
                });
            }

            // Toggle should remain state-based (no trigger guessing)
            if (mode === 'toggle') {
                // We can execute toggle immediately once we can resolve a target;
                // but we still might need to wait for off-canvas markup to mount.
            }

            let tries = 0;

            const tick = function () {
                // Resolve controls each tick (covers late-injected off-canvas)
                let controls = storedControls;

                if (!controls && storedName) {
                    const offCanvas = document.querySelector(
                        'section.e-off-canvas[aria-label="' + CSS.escape(storedName) + '"]'
                    );
                    if (offCanvas && offCanvas.id) {
                        controls = offCanvas.id; // "off-canvas-XXXX"
                        if (CONFIG.debug) log('Resolved name -> controls:', storedName, '=>', controls);
                    }
                }

                // If we still have nothing, keep waiting (up to max tries)
                if (!controls) {
                    tries += 1;
                    if (tries < CONFIG.maxRafTries) return requestAnimationFrame(tick);
                    if (CONFIG.debug) {
                        console.warn(
                            '[KCSS OffCanvas] Auto-open failed:',
                            'off-canvas not found for name="' + storedName + '"'
                        );
                    }
                    return;
                }

                // -------------------------
                // Toggle path (state-based)
                // -------------------------
                if (mode === 'toggle') {
                    let ok = false;

                    if (storedName) {
                        ok = handleToggleByName(storedName);
                    } else {
                        const m = String(controls).match(/^off-canvas-(.+)$/);
                        const elementorId = m && m[1] ? m[1] : '';
                        if (elementorId) ok = handleToggleById(elementorId);
                    }

                    if (ok) {
                        sessionStorage.removeItem(CONFIG.storageKey); // clear only on success
                    } else if (CONFIG.debug) {
                        warn('Toggle failed on destination:', { storedName, controls });
                    }
                    return;
                }

                // -------------------------
                // Open/Close path (trigger click)
                // -------------------------
                const triggers = document.querySelectorAll(
                    'a[aria-controls="' + CSS.escape(controls) + '"]'
                );

                if (triggers && triggers.length) {
                    const trigger = pickTriggerForMode(triggers, mode);

                    if (CONFIG.debug) {
                        log('Clicking native trigger:', {
                            controls: controls,
                            mode: mode,
                            href: trigger ? trigger.getAttribute('href') || '' : ''
                        });
                    }

                    if (trigger) {
                        trigger.click();
                        sessionStorage.removeItem(CONFIG.storageKey); // clear only after click
                        return;
                    }
                }

                tries += 1;
                if (tries < CONFIG.maxRafTries) return requestAnimationFrame(tick);

                if (CONFIG.debug) {
                    console.warn(
                        '[KCSS OffCanvas] Auto-open failed:',
                        'controls trigger not found (aria-controls="' + controls + '")'
                    );
                }
            };

            tick();
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', execute);
        } else {
            execute();
        }
    }

    // Focus management for off-canvas
    let lastFocusedElement = null;
    let offCanvasFocusObserver = null;

    /**
     * Store the currently focused element before off-canvas opens
     */
    function storeFocusedElement() {
        lastFocusedElement = document.activeElement;
        log('Stored focus element:', lastFocusedElement);
    }

    /**
     * Clear all focus states within an off-canvas element
     */
    function clearOffCanvasFocus(offCanvasElement) {
        if (!offCanvasElement) return;

        // Remove focus from any focused elements inside the off-canvas
        const focusedElements = offCanvasElement.querySelectorAll(':focus');
        focusedElements.forEach(el => {
            if (el && typeof el.blur === 'function') {
                el.blur();
                log('Blurred element:', el);
            }
        });

        // Also remove tabindex from any tabbable elements to fully remove them from tab order
        const tabbableElements = offCanvasElement.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        tabbableElements.forEach(el => {
            el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') || '0');
            el.setAttribute('tabindex', '-1');
        });

        log('Cleared focus from off-canvas elements');
    }

    /**
     * Restore focus states when off-canvas closes
     */
    function restoreOffCanvasFocus(offCanvasElement) {
        if (!offCanvasElement) return;


        // If this off-canvas manages its own focus (e.g. map markers), skip default restoration
        if (offCanvasElement.hasAttribute('data-kcss-focus-managed')) {
            log('Focus managed externally for this off-canvas, skipping default restoration.');
            lastFocusedElement = null;
            return;
        }
        // Restore original tabindex values
        const elementsWithStoredTabindex = offCanvasElement.querySelectorAll('[data-original-tabindex]');
        elementsWithStoredTabindex.forEach(el => {
            const originalTabindex = el.getAttribute('data-original-tabindex');
            if (originalTabindex === '0') {
                el.removeAttribute('tabindex');
            } else {
                el.setAttribute('tabindex', originalTabindex);
            }
            el.removeAttribute('data-original-tabindex');
        });

        // Return focus to the last focused element (usually the trigger)
        if (lastFocusedElement &&
            lastFocusedElement !== document.body &&
            document.contains(lastFocusedElement) &&
            typeof lastFocusedElement.focus === 'function') {

            setTimeout(() => {
                lastFocusedElement.focus();
                log('Restored focus to:', lastFocusedElement);
            }, 100); // Small delay to ensure off-canvas transition is complete
        }

        lastFocusedElement = null;
    }

    /**
     * Set up focus management for all off-canvas elements
     */
    function setupOffCanvasFocusManagement() {
        // Store focus when any trigger is clicked (before off-canvas opens)
        document.addEventListener('click', function(e) {
            const trigger = e.target.closest('[data-kcss-offcanvas-open], [data-kcss-offcanvas-toggle], [data-kcss-offcanvas]');
            if (trigger) {
                storeFocusedElement();
                log('Stored focus on trigger:', trigger);
            }
        }, true);

        // Create a single observer to watch all off-canvas elements
        if (!offCanvasFocusObserver) {

            offCanvasFocusObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
                        const offCanvas = mutation.target;
                        const isHidden = offCanvas.getAttribute('aria-hidden') === 'true';

                        if (isHidden) {
                            // Off-canvas is closing
                            log('Off-canvas closing, managing focus:', offCanvas);
                            clearOffCanvasFocus(offCanvas);
                            restoreOffCanvasFocus(offCanvas);
                        }
                    }
                });
            });

            // Observe all existing off-canvas elements
            const offCanvasElements = document.querySelectorAll(CONFIG.offCanvasSelector);
            offCanvasElements.forEach(function(offCanvas) {
                offCanvasFocusObserver.observe(offCanvas, {
                    attributes: true,
                    attributeFilter: ['aria-hidden']
                });
            });

            // Also observe for new off-canvas elements being added to the DOM
            const bodyObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.matches && node.matches(CONFIG.offCanvasSelector)) {
                                offCanvasFocusObserver.observe(node, {
                                    attributes: true,
                                    attributeFilter: ['aria-hidden']
                                });
                            } else if (node.querySelectorAll) {
                                const newOffCanvasElements = node.querySelectorAll(CONFIG.offCanvasSelector);
                                newOffCanvasElements.forEach(function(offCanvas) {
                                    offCanvasFocusObserver.observe(offCanvas, {
                                        attributes: true,
                                        attributeFilter: ['aria-hidden']
                                    });
                                });
                            }
                        }
                    });
                });
            });

            bodyObserver.observe(document.body, {
                childList: true,
                subtree: true
            });

            log('Off-canvas focus management initialized');
        }
    }

    // ---------------------------------------------------------------------------
    // Init
    // ---------------------------------------------------------------------------

    function init() {
        log('Init');
        setupOffCanvasTriggers();
        bindToggleDelegation();
        setupOffCanvasFocusManagement();

        bindArchiveEventHook();
        bindCrossPageCapture();
        autoExecuteIntentOnDestination();

        bindArchiveMutationHook();
        bindOffCanvasMountObserver();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // ---------------------------------------------------------------------------
    // Public helpers (QA / support)
    // ---------------------------------------------------------------------------
    window.KCSS_OffCanvas = {
        setDebug: function (val) {
            CONFIG.debug = !!val;
        },
        rewire: setupOffCanvasTriggers,

        // NEW: programmatic control (used by map markers, etc.)
        openByName: function (name) {
            const elementorId = resolveElementorIdFromName(name);
            if (!elementorId) return false;
            return executeActionById(elementorId, 'open');
        },
        closeByName: function (name) {
            const elementorId = resolveElementorIdFromName(name);
            if (!elementorId) return false;
            return executeActionById(elementorId, 'close');
        },
        toggleByName: function (name) {
            name = normaliseName(name);
            if (!name) return false;
            return handleToggleByName(name);
        }
    };
})();

function stickySectionHeading() {
    const els = Array.from(document.querySelectorAll(".kcss_section-header-sticky"));
    if (!els.length) return;

    const CLS_PINNED = "is-pinned";
    const CLS_TOP = "is-pinned--top";
    const CLS_BOTTOM = "is-pinned--bottom";
    const CLS_INVIEW = "is-in-viewport";
    const CLS_OUTVIEW = "is-out-of-viewport";

    // If your sticky uses offsets, set these (otherwise keep 0)
    const TOP_OFFSET = 0;
    const BOTTOM_OFFSET = 0;
    const TOL = 1;

    let ticking = false;

    const update = () => {
        const vh = window.innerHeight || document.documentElement.clientHeight;

        els.forEach(el => {
            if (!el.isConnected) return;

            const r = el.getBoundingClientRect();

            // 1) In viewport (any visible pixels)
            const inView = r.bottom > 0 && r.top < vh;

            // 2) Pinned to an edge (only meaningful if it's in view)
            const pinnedTop = inView && (r.top <= (TOP_OFFSET + TOL));
            const pinnedBottom = inView && (r.bottom >= (vh - BOTTOM_OFFSET - TOL));

            // Always set/unset based on CURRENT state
            el.classList.toggle(CLS_INVIEW, inView);
            el.classList.toggle(CLS_OUTVIEW, !inView);

            el.classList.toggle(CLS_TOP, pinnedTop);
            el.classList.toggle(CLS_BOTTOM, pinnedBottom);
            el.classList.toggle(CLS_PINNED, pinnedTop || pinnedBottom);

            // Optional: attributes for debugging / CSS hooks
            el.dataset.kcssInViewport = inView ? "1" : "0";
            el.dataset.kcssPinnedEdge = pinnedTop ? "top" : (pinnedBottom ? "bottom" : "");
        });
    };

    const rafUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            try { update(); } finally { ticking = false; }
        });
    };

    // Works without Lenis
    window.addEventListener("scroll", rafUpdate, { passive: true });
    window.addEventListener("resize", rafUpdate);

    // Works with Lenis (if present)
    const lenis = window.lenis;
    if (lenis && typeof lenis.on === "function") {
        lenis.on("scroll", rafUpdate);
    }

    rafUpdate();
}

window.stickySectionHeading = stickySectionHeading;

// Your init helper
runIfElementExists(".kcss_section-header-sticky", function () {
    window.stickySectionHeading();
});

/**
 * Pause videos (HTML5, YouTube, Vimeo) when an Elementor Off-Canvas closes.
 *
 * Supports:
 * - YouTube standard + privacy mode (youtube-nocookie.com)
 * - Elementor "image overlay" (iframe injected late)
 *
 * YouTube details:
 * - pauseVideo postMessage requires enablejsapi=1 on the iframe URL
 * - We attempt to retrofit enablejsapi=1 when the off-canvas OPENS,
 *   so pause works when it CLOSES.
 *
 * Lint goals:
 * - No short-circuit expressions used as statements
 * - No functions declared inside loops (no-loop-func)
 * - No optional chaining
 */

(() => {
    const CONFIG = {
        debug: false,
        offCanvasSelector: '.e-off-canvas',
        hardStopFallback: true // If JS API isn't enabled, reset iframe src to stop playback
    };

    function log() {
        if (!CONFIG.debug) return;
        console.log.apply(console, ['[PauseOffCanvas]'].concat([].slice.call(arguments)));
    }

    // ---------------------------------------------------------------------
    // Helpers: URL / platform detection
    // ---------------------------------------------------------------------

    function isYouTubeSrc(src) {
        const s = String(src || '').toLowerCase();
        return (
            s.indexOf('youtube.com') !== -1 ||
            s.indexOf('youtube-nocookie.com') !== -1 ||
            s.indexOf('youtu.be') !== -1
        );
    }

    function isVimeoSrc(src) {
        return String(src || '').toLowerCase().indexOf('vimeo.com') !== -1;
    }

    function hasEnableJsApi(src) {
        return /(?:\?|&)enablejsapi=1(?:&|$)/i.test(String(src || ''));
    }

    function addOrUpdateQueryParam(urlString, key, value) {
        try {
            const u = new URL(urlString, window.location.href);
            u.searchParams.set(key, value);
            return u.toString();
        } catch (e) {
            return urlString;
        }
    }

    // ---------------------------------------------------------------------
    // Helpers: hard-stop iframes (works even when postMessage is ignored)
    // ---------------------------------------------------------------------

    function hardStopIframe(frame) {
        if (!frame) return false;

        const originalSrc = frame.getAttribute('src');
        if (!originalSrc) return false;

        frame.setAttribute('src', 'about:blank');
        setTimeout(function () {
            frame.setAttribute('src', originalSrc);
        }, 0);

        log('Hard-stopped iframe by src reset:', originalSrc, frame);
        return true;
    }

    // ---------------------------------------------------------------------
    // Media pausing helpers
    // ---------------------------------------------------------------------

    function pauseHtml5Videos(root) {
        const vids = root.querySelectorAll('video');
        for (let i = 0; i < vids.length; i += 1) {
            const v = vids[i];
            try {
                v.pause();
                log('Paused HTML5 <video>', v);
            } catch (e) {
                log('HTML5 pause failed', e);
            }
        }
    }

    /**
     * Ensure YouTube iframes inside this off-canvas have enablejsapi=1
     * so that pauseVideo postMessage works later.
     */
    function ensureYouTubeJsApiEnabled(root) {
        const frames = root.querySelectorAll('iframe');
        for (let i = 0; i < frames.length; i += 1) {
            const frame = frames[i];
            const src = frame.getAttribute('src') || '';
            if (!src) continue;
            if (!isYouTubeSrc(src)) continue;
            if (hasEnableJsApi(src)) continue;

            const patched = addOrUpdateQueryParam(src, 'enablejsapi', '1');
            if (patched !== src) {
                frame.setAttribute('src', patched);
                log('Patched YouTube iframe to enable JS API:', patched, frame);
            }
        }
    }

    function pauseYouTube(root) {
        const frames = root.querySelectorAll('iframe');
        for (let i = 0; i < frames.length; i += 1) {
            const frame = frames[i];
            const src = frame.getAttribute('src') || '';

            if (!src) continue;
            if (!isYouTubeSrc(src)) continue;

            try {
                if (frame.contentWindow && typeof frame.contentWindow.postMessage === 'function') {
                    frame.contentWindow.postMessage(
                        JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
                        '*'
                    );
                    log('Sent YouTube pause postMessage', src, frame);
                } else {
                    log('YouTube iframe has no contentWindow.postMessage', src, frame);
                }

                // If JS API isn't enabled, postMessage often does nothing → hard stop
                if (CONFIG.hardStopFallback && !hasEnableJsApi(src)) {
                    hardStopIframe(frame);
                }
            } catch (e) {
                log('YouTube postMessage failed', e);
                if (CONFIG.hardStopFallback) {
                    hardStopIframe(frame);
                }
            }
        }
    }

    function pauseVimeo(root) {
        const frames = root.querySelectorAll('iframe');
        for (let i = 0; i < frames.length; i += 1) {
            const frame = frames[i];
            const src = frame.getAttribute('src') || '';

            if (!src) continue;
            if (!isVimeoSrc(src)) continue;

            try {
                if (frame.contentWindow && typeof frame.contentWindow.postMessage === 'function') {
                    frame.contentWindow.postMessage({ method: 'pause' }, '*');
                    log('Sent Vimeo pause postMessage', src, frame);
                } else {
                    log('Vimeo iframe has no contentWindow.postMessage', src, frame);
                }
            } catch (e) {
                log('Vimeo postMessage failed', e);
                if (CONFIG.hardStopFallback) {
                    hardStopIframe(frame);
                }
            }
        }
    }

    function pauseAllMedia(root) {
        if (!root) return;
        pauseHtml5Videos(root);
        pauseYouTube(root);
        pauseVimeo(root);
    }

    // ---------------------------------------------------------------------
    // Observe off-canvas aria-hidden changes
    // ---------------------------------------------------------------------

    function observeOneOffCanvas(offCanvasEl) {
        if (!offCanvasEl) return;

        const obs = new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i += 1) {
                const m = mutations[i];
                if (m.type !== 'attributes') continue;
                if (m.attributeName !== 'aria-hidden') continue;

                const aria = offCanvasEl.getAttribute('aria-hidden');
                log('aria-hidden changed:', aria, offCanvasEl);

                // Open: ensure API enabled for YouTube frames inside (if present)
                if (aria === 'false') {
                    ensureYouTubeJsApiEnabled(offCanvasEl);
                }

                // Close: pause
                if (aria === 'true') {
                    pauseAllMedia(offCanvasEl);
                }
            }
        });

        obs.observe(offCanvasEl, { attributes: true, attributeFilter: ['aria-hidden'] });

        // If it starts open, patch immediately
        if (offCanvasEl.getAttribute('aria-hidden') === 'false') {
            ensureYouTubeJsApiEnabled(offCanvasEl);
        }

        log('Observing off-canvas:', offCanvasEl);
    }

    function initExistingOffCanvas() {
        const nodes = document.querySelectorAll(CONFIG.offCanvasSelector);
        for (let i = 0; i < nodes.length; i += 1) {
            observeOneOffCanvas(nodes[i]);
        }
    }

    // Helper defined once (avoids no-loop-func)
    function handleAddedNode(node) {
        if (!(node instanceof HTMLElement)) return;

        // If the added node itself is an off-canvas, observe it
        if (node.matches && node.matches(CONFIG.offCanvasSelector)) {
            observeOneOffCanvas(node);
            return;
        }

        // Or if it contains off-canvas elements, observe those
        if (node.querySelectorAll) {
            const found = node.querySelectorAll(CONFIG.offCanvasSelector);
            for (let i = 0; i < found.length; i += 1) {
                observeOneOffCanvas(found[i]);
            }
        }
    }

    function observeNewOffCanvasMounts() {
        const mountObs = new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i += 1) {
                const m = mutations[i];
                if (!m.addedNodes || !m.addedNodes.length) continue;

                for (let j = 0; j < m.addedNodes.length; j += 1) {
                    handleAddedNode(m.addedNodes[j]);
                }
            }
        });

        mountObs.observe(document.body, { childList: true, subtree: true });
    }

    function boot() {
        initExistingOffCanvas();
        observeNewOffCanvasMounts();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    window.PauseOffCanvas = {
        setDebug: function (val) {
            CONFIG.debug = !!val;
        }
    };
})();

(() => {
    const header = document.querySelector('.kcss_site-header--scroll-hide');
    if (!header) return;

    // Classes
    const HIDE_CLASS = 'is--hidden';
    const FIXED_CLASS = 'is--fixed';
    const BODY_FIXED_CLASS = 'kcss_site-header--fixed';

    // When a section header is pinned to the TOP (and still in view), site header should stay hidden
    const PINNED_TOP_SELECTOR =
        '.kcss_section-header-sticky.is-pinned--top.is-in-viewport';

    let lastY = 0;
    let ticking = false;

    // Get "real" scroll position with/without Lenis
    const getScrollY = () => {
        const lenis = window.lenis;
        if (lenis) {
            if (typeof lenis.scroll === 'number') return lenis.scroll;
            if (typeof lenis.animatedScroll === 'number') return lenis.animatedScroll;
            if (typeof lenis.targetScroll === 'number') return lenis.targetScroll;
        }
        return window.scrollY || 0;
    };

    // Read header height from CSS var, with a DOM fallback if it's not ready yet
    const getHeaderHeight = () => {
        const val = getComputedStyle(document.documentElement)
            .getPropertyValue('--kcss-header-height')
            .trim();

        const num = parseFloat(val);
        if (Number.isFinite(num) && num > 0) return num;

        // Fallback: measure the Elementor header region if available
        const elHeader = document.querySelector('.elementor-location-header');
        if (elHeader && elHeader.offsetHeight) return elHeader.offsetHeight;

        // Final fallback: measure the actual header node we’re controlling
        return header.offsetHeight || 0;
    };

    const hasPinnedTopInView = () =>
        !!document.querySelector(PINNED_TOP_SELECTOR);

    const setFixed = (fixed) => {
        header.classList.toggle(FIXED_CLASS, fixed);
        document.body.classList.toggle(BODY_FIXED_CLASS, fixed);
        if (!fixed) header.classList.remove(HIDE_CLASS); // don’t allow hidden when unfixed
    };

    function update(y) {
        const buffer = getHeaderHeight();     // buffer == header height (custom property-driven)
        const fixed = y >= buffer;

        setFixed(fixed);

        // Within buffer: header is not fixed and always visible
        if (!fixed) {
            lastY = y;
            return;
        }

        // If a section header is pinned-top in view, keep site header hidden
        if (hasPinnedTopInView()) {
            header.classList.add(HIDE_CLASS);
            lastY = y;
            return;
        }

        // Hide on scroll down, show on scroll up
        if (y > lastY) header.classList.add(HIDE_CLASS);
        else header.classList.remove(HIDE_CLASS);

        lastY = y <= 0 ? 0 : y;
    }

    function rafTick() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
            try { update(getScrollY()); }
            finally { ticking = false; }
        });
    }

    // Works without Lenis
    window.addEventListener('scroll', rafTick, { passive: true });

    // Works with Lenis (if present)
    const lenis = window.lenis;
    if (lenis && typeof lenis.on === 'function') {
        lenis.on('scroll', rafTick);
    }

    // Keep things correct if header height changes after load (fonts/Elementor/responsive)
    window.addEventListener('resize', rafTick);

    // Init
    lastY = getScrollY();
    rafTick();
})();


(() => {
    const siteFooter = document.querySelector("footer");
    const siteMain = document.querySelector('[data-elementor-type="wp-page"]');
    const stickyClass = "kcss_site-footer--sticky";
    const footerHeight = siteFooter.offsetHeight / 2;

    if (!siteFooter || !siteMain) return;

    const DIST_FROM_BOTTOM = footerHeight; // px from bottom of viewport

    // Create a 2px sentinel at the bottom of main
    const sentinel = document.createElement("div");
    sentinel.setAttribute("data-footer-sentinel", "true");
    sentinel.style.cssText = "height:2px;width:1px;pointer-events:none;";
    siteMain.appendChild(sentinel);

    const observer = new IntersectionObserver(
        ([entry]) => {
            // When the sentinel enters the "trigger zone", add the class
            if (entry.isIntersecting) {
                siteFooter.classList.add(stickyClass);
            } else {
                siteFooter.classList.remove(stickyClass);
            }
        },
        {
            root: null,
            // Shrink the effective viewport by DIST_FROM_BOTTOM at the bottom.
            // So the sentinel becomes "intersecting" when it's within DIST_FROM_BOTTOM of the bottom.
            rootMargin: `0px 0px -${DIST_FROM_BOTTOM}px 0px`,
            threshold: 0
        }
    );

    observer.observe(sentinel);
})();


document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('body');
    const hero  = document.querySelector('.kcss_section--dynamic-hero');
    const stage = document.querySelector('.kcss_scroll-scale');
    if (!hero || !stage) return;

    const setHeroHeight = () => {
        body.style.setProperty('--kcss-hero-h', hero.offsetHeight + 'px');
    };

    setHeroHeight();
    window.addEventListener('resize', setHeroHeight);
    const cssNumber = (name, fallback) => {
        const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : fallback;
    };

    const startInsetEm = cssNumber('--kcss-gutter-start', 2.5);
    const endInsetEm   = cssNumber('--kcss-gutter-end', 0);

    const startOpacity = cssNumber('--kcss-opacity-start', 1);
    const endOpacity = cssNumber('--kcss-opacity-end', 0);

    const startAtVh = 0.25;
    const endAtVh   = 0.75;

    const clamp = (n,a,b)=>Math.min(b,Math.max(a,n));
    const lerp  = (a,b,t)=>a+(b-a)*t;

    const ease = t =>
        t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3)/2;

    let ticking = false;

    function update(){
        ticking = false;

        const rect = hero.getBoundingClientRect();
        const vh = window.innerHeight;
        const endStageVh = 1.05;
        const endHeight = vh * endStageVh;

        const startPx = vh * startAtVh;
        const endPx   = vh * endAtVh;

        const progressed = clamp(-rect.top - startPx, 0, endPx - startPx);
        const t = ease(progressed / (endPx - startPx));

        stage.style.setProperty(
            '--kcss-gutter',
            lerp(startInsetEm, endInsetEm, t) + 'em'
        );

        body.style.setProperty(
            '--kcss-hero-opacity',
            lerp(startOpacity, endOpacity, t)
        );

        body.style.setProperty(
            '--kcss-stage-h',
            lerp(
                parseFloat(getComputedStyle(hero).getPropertyValue('--kcss-hero-h')),
                endHeight, t) + 'px'
        );
    }

    function onScroll(){
        if(!ticking){
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    window.addEventListener('scroll', onScroll, { passive:true });
    update();
});